import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useEffect, useRef, useState } from "react";
import { ChevronLeft, Clock, Edit, Heart, LogIn, MessageCircle, Send, Smile, Trash, X, XSquare } from "react-feather";
import GiveCoffeeContent from "./give-coffee-content";
import { User } from "../../../global-components/src/types";
import { t } from "../../../global-components/src/i18nTranslate";


interface GiveCoffeeProps {
    user?: User | null;
}

const GiveCoffee: React.FC<GiveCoffeeProps> = ({ user }) => {
    const openModalLikesRef = useRef<HTMLButtonElement | null>(null);
    const closeModalLikesRef = useRef<HTMLButtonElement | null>(null);
    const closeModalRef = useRef<HTMLButtonElement | null>(null);

    useEffect(() => {
        closeModalRef.current?.click();
    }, [location.pathname]); // Executa toda vez que a URL muda

    return (
        <div className="modal fade" id={`give-coffee`} aria-hidden="true" style={{ zIndex: 17 }} >
            <div className="modal-dialog modal-dialog-centered foc-pc-dialog" role="document">
                <div className="modal-content foc-pc-modal-content">
                    <div className="foc-pc-header">
                        <h4 className="foc-pc-title">{t("post.actions.sendCoffee")}</h4>
                        <div className="d-flex" style={{ gap: 5 }}>
                            <button
                                ref={closeModalRef}
                                type="button"
                                className="foc-pc-close"
                                data-bs-dismiss="modal"
                                aria-label="Fechar"
                            >
                                ✕
                            </button>
                        </div>
                    </div>

                    <GiveCoffeeContent onClose={ () => closeModalLikesRef.current?.click() } user={user}/>
                </div>

            </div>

            <button className="d-none" ref={openModalLikesRef} data-bs-dismiss="modal" data-bs-toggle="modal" data-bs-target={`#give-coffee`}>a</button>
        </div>
    );
};

export default GiveCoffee;
